import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IInstallmentState } from '@/models/store/installments/installment-state.module';
import { IInstallment } from '@/models/store/installments/installment.module';
import { Module } from 'vuex';

const installmentModule: Module<IInstallmentState, unknown> = {
    state: {
        installments: [],
    },

    actions: {
        fetchInstallments: async ({ commit }, payload: number) => {
            const params = new URLSearchParams();
            params.append('pageNumber', payload ? String(payload) : '0');

            const response = await fetch(`${environment.baseUrl}/api/installment?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const installments = (await response.json()).data;
            commit('setInstallments', installments);
        },
    },

    mutations: {
        setInstallments: async (store, payload: IInstallment[]) => {
            store.installments = [...payload];
        },
    },

    getters: {
        getInstallments: (store) => store.installments,
    },
};

export default installmentModule;
